module.exports = __webpack_public_path__ + "static/media/Tooth_icon_ffd600.2feabaad.svg";